export const BILLING_LOGS = (COMMUNITY_ID: string) =>
  `v1/community/${COMMUNITY_ID}/billing-logs`;
export const TRANSACTION_HISTORY = (communityId: string) => `v1/property-ownerships/community/${communityId}/transaction-history`;
